var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32625 6.92423C4.85328 6.56646 4.26477 6.35376 3.62734 6.35376C2.185 6.35376 0.992695 7.44181 0.826172 8.84005H4.595C4.67187 8.13497 4.9307 7.47903 5.32625 6.92423Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62653 5.18177C4.57778 5.18177 5.45223 5.51626 6.13895 6.07353C6.50712 5.78563 6.92681 5.55923 7.38356 5.4113C7.51157 5.1336 7.66884 4.87056 7.85251 4.62579L4.51423 3.30481C4.36622 3.24618 4.20083 3.2504 4.05598 3.3163C3.91114 3.38224 3.79931 3.50423 3.74622 3.65423C3.57063 4.1506 3.51766 4.67235 3.58462 5.18231C3.5986 5.18216 3.61251 5.18177 3.62653 5.18177Z",
    fill: "#E9A5F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3265 3.00349C9.81074 2.44704 9.0743 2.0979 8.25754 2.0979C7.54957 2.0979 6.90219 2.36056 6.40625 2.79278L8.76387 3.72571C9.23289 3.38196 9.7641 3.13708 10.3265 3.00349Z",
    fill: "#E9A5F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26441 6.40981C6.98785 6.57376 5.96953 7.57298 5.77539 8.83997H19.7293C19.6371 7.94349 19.0749 7.17485 18.2622 6.81325C18.1339 5.60556 17.1439 4.65146 15.9205 4.57903C15.4824 3.62962 14.5242 2.99927 13.4496 2.99927C12.6031 2.99927 11.8073 3.39704 11.296 4.0572C10.5155 4.06567 9.76992 4.35896 9.19285 4.88517C8.74 5.29813 8.42 5.82724 8.26441 6.40981Z",
    fill: "#E9A5F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4064 9.97314H0.593525C0.227236 9.97314 -0.0519438 10.3021 0.00817337 10.6634C0.239423 12.0534 0.843173 13.369 1.76493 14.4602C2.84337 15.7368 4.29653 16.6404 5.89751 17.0394V17.3103C5.89751 17.6371 6.16243 17.902 6.48923 17.902H13.5108C13.8375 17.902 14.1024 17.6371 14.1024 17.3103V17.0394C15.7034 16.6405 17.1566 15.7369 18.235 14.4602C19.1568 13.369 19.7605 12.0534 19.9918 10.6634C20.0519 10.3021 19.7727 9.97314 19.4064 9.97314Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalad);
export default __webpack_public_path__ + "static/media/salad.51bf2943037953dc571026f3b1541302.svg";
export { ForwardRef as ReactComponent };